import axios from 'axios';
import store from './store/store';

export const HTTP = axios.create({
  baseURL: process.env.VUE_APP_AXIOS_HOST
});

HTTP.interceptors.request.use(config => {
  if (localStorage.getItem('exideUser')) {
    config.headers.common['Authorization'] =
      'Bearer ' + JSON.parse(localStorage.getItem('exideUser')).token;
  }
  return config;
});

HTTP.interceptors.response.use(
  response => {
    return response;
  },
  error => {
    if (error.response.status === 401 || error.response.status === 403) {
      store.dispatch('logoutAction');
    }
    // todo: add global error handling
    return Promise.reject(error);
  }
);
